import axios from 'axios'

const user = axios.create({
    // baseURL: 'http://localhost:3005/user',
    // baseURL: 'https://enigmatic-wave-58349.herokuapp.com/user'
    // baseURL: 'http://ec2-18-216-231-108.us-east-2.compute.amazonaws.com:3005/user'
    baseURL: 'https://0687-18-216-231-108.ngrok.io/user'
})

const userbook = axios.create({
    // baseURL: 'http://localhost:3005/api',
    // baseURL: 'https://enigmatic-wave-58349.herokuapp.com/api'
    // baseURL: 'http://ec2-18-216-231-108.us-east-2.compute.amazonaws.com:3005/api'
    baseURL: 'https://0687-18-216-231-108.ngrok.io/api'

})

// user actions
export const register = info => user.post('register', info)
export const login = info => user.post('login', info)

// user-book interactions
export const createUserbook = bookinfo => userbook.post('/createUserbook', bookinfo)
export const updateUserbook = bookinfo => userbook.put('/updateUserbook', bookinfo)
export const getUserbooks = info => userbook.post('/getUserbooks', info)
export const addJournal = info => userbook.post('/addJournal', info)
export const getJournals = info => userbook.post('/getJournals', info)

const routes = {
    register, login,
    createUserbook, updateUserbook, getUserbooks, addJournal, getJournals
}

export default routes